// extracted by mini-css-extract-plugin
module.exports = {"checkbox-group":"_373a3719ba--checkbox-group--VvtN1"};